
























































































import { Card } from "ant-design-vue";
import moment from "moment";
import { Component, Emit, Prop, Vue, Watch } from 'vue-property-decorator';

import Accordion from "../../../../../components/Accordion/Accordion.vue";
import AvatarsRow from "../../../../../components/AvatarsRow.vue";
import PostSettingsIcons from "../../components/PostSettingsIcons.vue";
import { PostType } from "../../types";
import { DatePostsItem } from "../types";

@Component({
  data() {
    return {
      PostType
    }
  },
  methods: {
    moment
  },
  components: {
    PostSettingsIcons,
    Accordion,
    AvatarsRow
  }
})
export default class DatePostsList extends Vue {
  @Prop() posts!: Array<DatePostsItem>

  @Prop({ required: true, type: String }) selectedDate !: string

  @Prop({ required: true, type: String }) selectedTime !: string | null

  @Prop() postColorsHelpMessage!: string

  @Prop() createPostButtonTitle!: string

  @Watch('posts')
  onPostsChange() {
    this.postsToShow = []

    this.loadMorePosts()
  }

  @Emit()
  selectPost(post: DatePostsItem) {
    return post
  }

  @Emit()
  createPostButtonClick() {
    return {
      date: this.selectedDate,
      query: {
        date: this.selectedDate,
        ...this.selectedTime ? {
          time: this.selectedTime
        } : {}
      }
    }
  }

  @Emit()
  scrollTo(y: number): number {
    return y
  }

  @Watch('selectedTime')
  selectedTimeWatcher(selectedTime: string | null): void {
    if (selectedTime) {
      const time = moment(selectedTime, 'HH:mm')

      const post = this.posts.find(p => {
        const postTimeFormat = moment(p.start).format('HH:mm')

        return moment(postTimeFormat, 'HH:mm').isSameOrAfter(time, 'h')
      })

      if (post) {
        this.$nextTick(() => {
          const postRef = this.$refs[post.key]

          if (Array.isArray(postRef)) {
            const card = (postRef[0] as Card).$el as HTMLDivElement

            this.scrollTo(card.offsetTop - card.clientHeight)
          }
        })
      }
    }
  }

  postsToShow: Array<DatePostsItem> = []

  get customButtonTitleOrDefault() {
    if (this.createPostButtonTitle) {
      return this.createPostButtonTitle
    } else {
      return this.$t('post_module_create_post_button_title').toString()
    }
  }

  get sortedByTimePosts() {
    return this.posts.slice().sort((a, b) => {
      const missDate = new Date(Number.MAX_SAFE_INTEGER).getTime()

      return (a.start?.getTime() ?? missDate) - (b.start?.getTime() ?? missDate)
    })
  }

  get formattedDate() {
    return moment(this.selectedDate).format('D MMMM')
  }

  loadMorePosts() {
    this.postsToShow.push(...this.sortedByTimePosts.slice(this.postsToShow.length, this.postsToShow.length + 50))
  }

  created() {
    this.loadMorePosts()
  }
}
